module.exports = __webpack_public_path__ + "img/4_Proximal.03e167ff.png";